export default {
  MAX_NETSUITE_UPLOAD_SIZE: 10000000,

  validEmail (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  validZip (zip) {
    const countryField = document.getElementById('country-dropdown')
    const countryCode = countryField.options[countryField.selectedIndex].value

    switch (countryCode) {
      // US
      case '230':
      case 'US':
        // Original code updated to accept all valid US zip codes (XXXXX-YYYY was incorrectly marked as invalid)
        // return /^\d{5}$/.test(zip)
        // SO: https://stackoverflow.com/a/56739221/2096769
        return /^\d{5}[-\s]?(?:\d{4})?$/.test(zip)
        // Canada
      case '37':
      case 'CA':
        return /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(zip)
        // Australia
      case '14':
      case 'AU':
        return /^\d{4}$/.test(zip)
        // Austria
      case '13':
      case 'AT':
        return /^\d{4}$/.test(zip)
        // Belgium
      case '20':
      case 'BE':
        return /^\d{4}$/.test(zip)
        // Bulgaria
      case '22':
      case 'BG':
        return /^\d{4}$/.test(zip)
        // Croatia
      case '98':
      case 'HR':
        return /^\d{5}$/.test(zip)
        // Cyprus
      case '55':
      case 'CY':
        return /^\d{4}$/.test(zip)
        // Czech Republic
      case '56':
      case 'CZ':
        return /^\d{6}$/.test(zip)
        // Denmark
      case '59':
      case 'DK':
        return /^\d{4}$/.test(zip)
        // Estonia
      case '64':
      case 'EE':
        return /^\d{5}$/.test(zip)
        // Finland
      case '70':
      case 'FI':
        return /^\d{5}$/.test(zip)
        // France
      case '75':
      case 'FR':
        return /^\d{5}$/.test(zip)
        // Germany
      case '57':
      case 'DE':
        return /^\d{5}$/.test(zip)
        // Hungary
      case '100':
      case 'HU':
        return /^\d{4}$/.test(zip)
        // Iceland
      case '109':
      case 'IS':
        return /^\d{3}$/.test(zip)
        // Ireland
      case '102':
      case 'IE':
        return /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/.test(zip)
        // Israel
      case '103':
      case 'IL':
        return /^\d{7}$/.test(zip)
        // Italy
      case '110':
      case 'IT':
        return /^\d{5}$/.test(zip)
        // Latvia
      case '135':
      case 'LV':
        return /^([Ll][Vv][- ]{0,1})[0-9]{4}$/.test(zip)
        // Lithuania
      case '133':
      case 'LT':
        return /^([Ll][Tt][- ]{0,1}){0,1}\d{5}$/.test(zip)
        // Luxemborg
      case '134':
      case 'LU':
        return /^\d{4}$/.test(zip)
        // Malta
      case '153':
      case 'MT':
        return /^[A-Za-z]{3}\s{0,1}\d{4}$/.test(zip)
        // Mexico
      case '157':
      case 'MX':
        return /^\d{5}$/.test(zip)
        // Netherlands
      case '166':
      case 'NL':
        return /^\d{4}\s{0,1}[A-Za-z]{2}$/.test(zip)
        // New Zealand
      case '171':
      case 'NZ':
        return (/^\d{4}$/.test(zip))
        // Norway
      case '167':
      case 'NO':
        return (/^\d{4}$/.test(zip))
        // Poland
      case '179':
      case 'PL':
        return /^\d{2}[- ]{0,1}\d{3}$$/.test(zip)
        // Portugal
      case '184':
      case 'PT':
        return /^\d{4}$/.test(zip)
        // Romania
      case '189':
      case 'RO':
        return /^\d{6}$/.test(zip)
        // Russia
      case '190':
      case 'RU':
        return /^\d{6}$/.test(zip)
        // Slovakia
      case '201':
      case 'SK':
        return /^\d{3}\s?\d{2}$/.test(zip)
        // Slovenia
      case '199':
      case 'SI':
        return /^\d{4}$/.test(zip)
        // Spain
      case '68':
      case 'ES':
        return /^\d{5}$/.test(zip)
        // Sweden
      case '196':
      case 'SE':
        return /^\d{3}\s*\d{2}$/.test(zip)
        // Switzerland
      case '42':
      case 'CH':
        return /^\d{4}$/.test(zip)
        // Turkey
      case '222':
      case 'TR':
        return /^\d{5}$/.test(zip)
        // Ukraine
      case '227':
      case 'UA':
        return /^\d{5}$/.test(zip)
        // United Arab Emirates - no postal codes, should be empty
      case '2':
      case 'AE':
        return zip === ''
        // United Kingdom
      case '77':
      case 'GB':
        //   return /^[A-Za-z]{1,2}[\d]{1,2}([A-Za-z])?\s?[\d][A-Za-z]{2}$/.test(zip);
        return /^(\w{1,2}\d{1,2}\w?\s\d\w{1,2})$/.test(zip)
        // Vietnam
      case '238':
      case 'VN':
        return /^\d{6}$/.test(zip)
        // Invalid or not defined
      default:
        return false
    }
  },

  // format file size to B, KB, or MB (from MDN)
  formatFileSize (number) {
    if (number < 1024) {
      return number + ' bytes'
    } else if (number >= 1024 && number < 1048576) {
      return (number / 1024).toFixed(1) + ' KB'
    } else if (number >= 1048576) {
      return (number / 1048576).toFixed(1) + ' MB'
    }
  },

  getTotalFileSizes (fileElements) {
    let totalFileSize = 0

    for (const file of fileElements) {
      if (file.files.length > 0) {
        totalFileSize = totalFileSize + file.files[0].size
      }
    }

    return totalFileSize
  },

  validNetSuiteUploadSize (totalFileSize, maxFileSize = this.MAX_NETSUITE_UPLOAD_SIZE) {
    return totalFileSize < maxFileSize
  },

  updateFilesProgressBar (totalFileSize, totalTextElement, progressBarElement, percentageElement, maxFileSize = this.MAX_NETSUITE_UPLOAD_SIZE) {
    // Show files progress bar
    const filesWrapper = progressBarElement.closest('.files-wrapper')

    if (filesWrapper) {
      filesWrapper.classList.replace('hidden', 'block')
    }

    // Update bar progress + text
    const percentFileSize = Math.round((totalFileSize / maxFileSize) * 100)

    totalTextElement.innerText = this.formatFileSize(totalFileSize)
    progressBarElement.setAttribute('aria-valuenow', percentFileSize)
    progressBarElement.style.width = Math.min(Math.floor(percentFileSize), 100) + '%'
    percentageElement.innerText = percentFileSize + '%'

    // Add error if file size is too big
    if (percentFileSize >= 100) {
      progressBarElement.classList.add('progressbar-error')
    } else {
      progressBarElement.classList.remove('progressbar-error')
    }
  },

  // check that all uploaded files are proper format, takes an array of mime types like image/jpeg or application/pdf
  // the file input field should have the same mime types in its "accept" parameter
  // note that image/jpeg includes both .jpg and .jpeg file extensions
  validFileFormat (acceptedTypes, fileElements) {
    if (!acceptedTypes) {
    // no file types defined, assume all ok
      return true
    }

    let stringFileTypes = 'Accepted file types: '
    acceptedTypes.forEach((type) => {
      stringFileTypes += '.' + type.split('/')[1] + ', '
      // for jpgs
      if (type === 'image/jpeg') {
        stringFileTypes += '.jpg, '
      }
    })
    stringFileTypes = stringFileTypes.slice(0, -2)

    for (const file of fileElements) {
      if (file.files.length > 0) {
        if (!acceptedTypes.includes(file.files[0].type)) {
          alert('Incorrect file type. ' + stringFileTypes)
          return false
        }
      }
    }
    return true
  },

  handleCountryStateZip (countryDropdown = document.querySelector('#country-dropdown')) {
    countryDropdown.addEventListener('change', () => {
      this.updateStateField()
      this.updateZipField()
    })
  },

  updateStateField (countryField = document.querySelector('#country-dropdown'),
    stateDropdown = document.querySelector('#state-dropdown')) {
    const countryCode = countryField.options[countryField.selectedIndex].value

    switch (countryCode) {
      case '230':
      case 'US':
        // US
        // Enable state dropdown
        stateDropdown.disabled = false
        stateDropdown.closest('.a-input-select').classList.remove('hidden')
        stateDropdown.innerHTML = "<option value='' selected>Select state</option><option value='0' >Alabama</option><option value='1' >Alaska</option><option value='2' >Arizona</option><option value='3' >Arkansas</option><option value='53' >Armed Forces Americas</option><option value='52' >Armed Forces Europe</option><option value='54' >Armed Forces Pacific</option><option value='4' >California</option><option value='5' >Colorado</option><option value='6' >Connecticut</option><option value='7' >Delaware</option><option value='8' >District of Columbia</option><option value='9' >Florida</option><option value='10' >Georgia</option><option value='11' >Hawaii</option><option value='12' >Idaho</option><option value='13' >Illinois</option><option value='14' >Indiana</option><option value='15' >Iowa</option><option value='16' >Kansas</option><option value='17' >Kentucky</option><option value='18' >Louisiana</option><option value='19' >Maine</option><option value='20' >Maryland</option><option value='21' >Massachusetts</option><option value='22' >Michigan</option><option value='23' >Minnesota</option><option value='24' >Mississippi</option><option value='25' >Missouri</option><option value='26' >Montana</option><option value='27' >Nebraska</option><option value='28' >Nevada</option><option value='29' >New Hampshire</option><option value='30' >New Jersey</option><option value='31' >New Mexico</option><option value='32' >New York</option><option value='33' >North Carolina</option><option value='34' >North Dakota</option><option value='35' >Ohio</option><option value='36' >Oklahoma</option><option value='37' >Oregon</option><option value='38' >Pennsylvania</option><option value='39' >Puerto Rico</option><option value='40' >Rhode Island</option><option value='41' >South Carolina</option><option value='42' >South Dakota</option><option value='43' >Tennessee</option><option value='44' >Texas</option><option value='45' >Utah</option><option value='46' >Vermont</option><option value='47' >Virginia</option><option value='48' >Washington</option><option value='49' >West Virginia</option><option value='50' >Wisconsin</option><option value='51' >Wyoming</option>"
        break
      case '37':
      case 'CA':
        // Canada
        // Enable state dropdown
        stateDropdown.disabled = false
        stateDropdown.closest('.a-input-select').classList.remove('hidden')
        stateDropdown.innerHTML = "<option value='' selected>Select province</option><option value='101'>Alberta</option><option value='102'>British Columbia</option><option value='103'>Manitoba</option><option value='104'>New Brunswick</option><option value='105'>Newfoundland</option><option value='107'>Northwest Territories</option><option value='106'>Nova Scotia</option><option value='108'>Nunavut</option><option value='109'>Ontario</option><option value='110'>Prince Edward Island</option><option value='111'>Quebec</option><option value='112'>Saskatchewan</option><option value='113'>Yukon</option>"
        break
      default:
        // Others
        // Disable state dropdown
        stateDropdown.disabled = true
        stateDropdown.closest('.a-input-select').classList.add('hidden')
    }
  },

  updateZipField (countryField = document.querySelector('#country-dropdown'),
    zipField = document.querySelector('#zip-field'),
    zipLabel = document.querySelector('#zip-label')) {
    const countryCode = countryField.options[countryField.selectedIndex].value
    const requiredStar = ' *'
    const noStarZip = zipLabel.innerHTML.replace(requiredStar, '')
    const withStarZip = noStarZip + requiredStar

    switch (countryCode) {
      case '2':
        // United Arab Emirates has no postal codes
        zipField.disabled = true
        zipField.value = ''
        zipLabel.innerHTML = noStarZip
        break
      default:
        zipField.disabled = false
        zipLabel.innerHTML = withStarZip
    }
  },

  // Handle country subsidiary
  // Start change subsidiary based on country selected - CMC - 07/27/2021 */
  handleCountrySubsidiary (subsidiarySelector = '#subsidiary', countrySelector = '#country-dropdown', custLocationSelector = '.cust_location') {
    const subsidiaryElem = document.querySelector(subsidiarySelector)
    const countryDropdownElem = document.querySelector(countrySelector)
    const custLocationElem = document.querySelectorAll(custLocationSelector)

    countryDropdownElem.addEventListener('change', function () {
      switch (this.value) {
        case '230': // US/Canada/Mexico
        case '37':
        case '157':
        case 'US':
        case 'CA':
          if (subsidiaryElem) {
            subsidiaryElem.value = 1
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 379
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
        case '77':
        case 'GB':
          if (subsidiaryElem) {
            subsidiaryElem.value = 3
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 213
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
        default:
          if (subsidiaryElem) {
            subsidiaryElem.value = 3 // UK
          } else {
            console.warn('Subsidiary hidden input not found')
          }

          if (custLocationElem) {
            custLocationElem.forEach(function (item) {
              item.value = 225
            })
          } else {
            console.warn('Customer Location hidden input not found')
          }
          break
      }
    })
  },

  handleKJProductTypeDropdown () {
    /*
    second value is for Size of Grill,
    see https://3424956.app.netsuite.com/app/common/custom/custlist.nl?id=317&e=T&ord=T to add values when a new grill or major accessory is introduced
    see https://3424956.app.netsuite.com/app/common/custom/custrecordentrylist.nl?rectype=317 and hover over edit/view to see the id
     */
    const models =
    {
      3: [
        ['BJ-ALUMN', '13', 'Aluminum Side Shelves, Big Joe'],
        ['BJ-DJ', '17', 'DōJoe, Big Joe'],
        ['BJ-GC24B', '13', 'Grill Cover, Big Joe'],
        ['BJ-GC24BWFS', '13', 'Grill Cover, Big Joe, Black'],
        ['BJ-GCARKANSAS', '13', 'Grill Cover, Big Joe, Arkansas'],
        ['BJ-GCCLEMSON', '13', 'Grill Cover, Big Joe, Clemson'],
        ['BJ-GCFLORIDA', '13', 'Grill Cover, Big Joe, Florida'],
        ['BJ-GCMONTREAL', '13', 'Grill Cover, Big Joe, Montreal'],
        ['BJ-GCNCAROLINA', '13', 'Grill Cover, Big Joe, North Carolina'],
        ['BJ-GCOLEMISS', '13', 'Grill Cover, Big Joe, Ole Miss'],
        ['BJ-GCTENNESSEE', '13', 'Grill Cover, Big Joe, Tennessee'],
        ['BJ-GCTORONTO', '13', 'Grill Cover, Big Joe, Toronto'],
        ['BJ-HCG', '13', 'Half-Moon Stainless Steel Cooking Grate, Big Joe'],
        ['BJ-HCGSSTONE', '13', 'Half-Moon Soapstone, Big Joe'],
        ['BJ-HCICG', '13', 'Half-Moon Cast Iron Cooking Grate, Big Joe'],
        ['BJ-HCIGRIDDLE', '13', 'Half-Moon Cast Iron Reversisble Griddle, Big Joe'],
        ['BJ-HDP', '13', 'Half-Moon Deflector Plates, Big Joe'],
        ['BJ-HDPEKIT', '13', 'HDPE Upgrade Kit, Big Joe'],
        ['BJ-HSSCGFV', '13', 'Half-Moon Stainless Steel Fish & Veg Grate, Big Joe'],
        ['BJ-HYPER', '13', 'SlōRoller with Rack, Big Joe'],
        ['BJ-MC3', '13', 'Cart, Big Joe'],
        ['BJ-MCC24', '13', 'Charcoal Basket, Big Joe'],
        ['BJ-PS24', '13', 'Ceramic Pizza Stone, Big Joe'],
        ['BJ-SCS', '13', 'Grill Expander, Big Joe'],
        ['BJ-TISSERIEAU', '13', 'JoeTisserie, Big Joe, Australia'],
        ['BJ-TISSERIEEU', '13', 'JoeTisserie, Big Joe, Europe'],
        ['BJ-TISSERIENA', '13', 'JoeTisserie, Big Joe, N. America'],
        ['BJ-TISSERIEUK', '13', 'JoeTisserie, Big Joe, UK'],
        ['KJ15080320', '13', 'Cover, Kettle Joe'],
        ['KJ15080420', '13', 'Cover, Joe Jr'],
        ['KJ15080520', '13', 'Dome Cover, Classic Joe'],
        ['KJ15080620', '13', 'Dome Cover, Big Joe'],
        ['KJ15090620', '13', 'Sear Plate'],
        ['KJ15090720', '13', 'Soapstone, Joe Jr'],
        ['KJ15091121', '13', 'Charcoal Basket, Joe Jr'],
        ['KJ15091620', '13', 'JoeTisserie Basket Set'],
        ['KJ15094522', '13', 'Karbon Steel Griddle, Classic Joe'],
        ['KJ15094622', '13', 'Karbon Steel Griddle, Big Joe'],
        ['KJ15100921', '13', 'Grill Cart, Black, Classic Joe III'],
        ['KJ15101021', '13', 'Grill Cart, Black, Big Joe III'],
        ['KJ15112524', '13', 'Joe Jr Cart with Shelves'],
        ['KJ15124722', '13', 'Karbon Steel Paella Pan'],
        ['KJ15124822', '13', 'Karbon Steel Half Moone Pan Set'],
        ['KJ15124922', '13', 'Karbon Steel Wok'],
        ['KJ15172022', '13', 'JoeTisserie Basket Kit'],
        ['KJ-ALUMN', '13', 'Aluminum Side Shelves, Classic Joe'],
        ['KJ-BL', '13', 'Blow Lighter'],
        ['KJ-CART', '13', 'Modular Cart, Classic Joe'],
        ['KJ-CS', '13', 'Ceramic Chicken Stand'],
        ['KJ-DDPS', '13', 'Deep Dish Pizza Stone'],
        ['KJ-DJ', '17', 'DōJoe, Classic Joe'],
        ['KJ-DO', '13', 'Dutch Oven'],
        ['KJ-ES', '13', 'Electric Starter'],
        ['KJ-GC23B.CART', '13', 'Grill Cover, Classic Joe Modular Cart'],
        ['KJ-GC23BWFS', '13', 'Grill Cover, Classic Joe, Black'],
        ['KJ-GCALABAMA', '13', 'Grill Cover, Classic Joe, Alabama'],
        ['KJ-GCAUBURN', '13', 'Grill Cover, Classic Joe, Auburn'],
        ['KJ-GCCLEMSON', '13', 'Grill Cover, Classic Joe, Clemson'],
        ['KJ-GCFLORIDASTATE', '13', 'Grill Cover, Classic Joe, Florida State'],
        ['KJ-GCMONTREAL', '13', 'Grill Cover, Classic Joe, Montreal'],
        ['KJ-GCOLEMISS', '13', 'Grill Cover, Classic Joe, Ole Miss'],
        ['KJ-GCTENNESSEE', '13', 'Grill Cover, Classic Joe, Tennessee'],
        ['KJ-GCTORONTO', '13', 'Grill Cover, Classic Joe, Toronto'],
        ['KJ-HCG', '13', 'Half-Moon Stainless Steel Cooking Grate, Classic Joe'],
        ['KJ-HCGSSTONE', '13', 'Half-Moon Soapstone, Classic Joe'],
        ['KJ-HCICG', '13', 'Half-Moon Cast Iron Cooking Grate, Classic Joe'],
        ['KJ-HCIGRIDDLE', '13', 'Half-Moon Cast Iron Reversisble Griddle, Classic Joe'],
        ['KJ-HDP', '13', 'Half-Moon Deflector Plates, Classic Joe'],
        ['KJ-HDPEKIT', '13', 'HDPE Upgrade Kit, Classic Joe'],
        ['KJ-HSSCGFV', '13', 'Half-Moon Stainless Steel Fish & Veg Grate, Classic Joe'],
        ['KJ-HYPER', '13', 'SlōRoller with Rack, Classic Joe'],
        ['KJ-IHP13', '13', 'Heat Deflector, Joe Jr'],
        ['KJ-IHPR13', '13', 'Rack Accessory, Joe Jr'],
        ['KJ-MC3', '13', 'Cart, Classic Joe'],
        ['KJ-MCC23', '13', 'Charcoal Basket, Classic Joe'],
        ['KJ-PC', '13', 'Pizza Cutter'],
        ['KJ-PP', '13', 'Pizza Peel'],
        ['KJ-PS23', '13', 'Ceramic Pizza Stone, Classic Joe'],
        ['KJ-RR', '13', 'Stainless Steel Rib Rack'],
        ['KJ-SCS', '13', 'Classic Joe Grill Expander'],
        ['KJ-TISSERIEAU', '13', 'JoeTisserie, Classic Joe, Australia'],
        ['KJ-TISSERIEEU', '13', 'JoeTisserie, Classic Joe, Europe'],
        ['KJ-TISSERIENA', '13', 'JoeTisserie, Classic Joe, N. America'],
        ['KJ-TISSERIEUK', '13', 'JoeTisserie, Classic Joe, UK'],
        ['KJ-WOK', '13', 'Wok'],
        ['PJ-STAND', '13', 'Pro Joe Stone Stand']
      ],
      24: [
        ['BJ24NRHC', '12', 'Big Joe II, Standalone'],
        ['BJ24NRHCI', '5', 'Big Joe III, Standalone'],
        ['BJ24RH', '10', 'Big Joe I'],
        ['BJ24RHC', '4', 'Big Joe II'],
        ['KJ13BH', '6', 'Joe Jr, Black'],
        ['KJ13RH', '6', 'Joe Jr'],
        ['KJ15040721', '19', 'Classic Joe III, Standalone'],
        ['KJ15040821', '18', 'Big Joe III, Standalone'],
        ['KJ15040921', '3', 'Classic Joe III'],
        ['KJ15041021', '5', 'Big Joe III'],
        ['KJ15041123', '20', 'Konnected Joe, N. America'],
        ['KJ15041523', '20', 'Konnected Joe, Outside N. America'],
        ['KJ15042425', '21', 'Big Joe Konnected Joe, N. America'],
        ['KJ15042525', '21', 'Big Joe Konnected Joe, Outside N. America'],
        ['KJ23B', '1', 'Classic Joe I, Black'],
        ['KJ23BH', '1', 'Classic Joe I, Black, with tools'],
        ['KJ23BHC', '2', 'Classic Joe II, Black'],
        ['KJ23NRHC', '11', 'Classic Joe II, Standalone'],
        ['KJ23NRHCI', '3', 'Classic Joe III, Standalone'],
        ['KJ23RH', '1', 'Classic Joe I'],
        ['KJ23RHC', '2', 'Classic Joe II'],
        ['PJ24NRHC', '7', 'Pro Joe']
      ],
      21: [
        ['KJ15260020', '8', 'Pellet Joe']
      ],
      8: [
        ['KJ15040320', '9', 'Kettle Joe']
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    const modelLabel = document.querySelector('#model-number-label')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar

    productTypeField.addEventListener('change', function () {
      modelSelect.length = 1
      if (models[this.value]) {
        models[this.value].forEach((element) => {
          /* adding element[1] for size of grill */
          modelSelect.append(new Option(element[0] + ', ' + element[2], element[0] + ',' + element[1]))
        })
        /* make it required */
        modelSelect.closest('.a-input-select').classList.remove('hidden')
        modelSelect.setAttribute('required', true)
        modelSelect.removeAttribute('disabled')
        modelLabel.innerHTML = withStar
      } else if (this.value === '37') {
        /* gift card, no model number required */
        modelSelect.closest('.a-input-select').classList.add('hidden')
        modelSelect.removeAttribute('required')
        modelSelect.setAttribute('disabled', true)
        modelLabel.innerHTML = noStar
      } else {
        /* nothing to select, not required */
        modelSelect.closest('.a-input-select').classList.remove('hidden')
        modelSelect.removeAttribute('required')
        modelSelect.setAttribute('disabled', true)
        modelLabel.innerHTML = noStar
      }
    })
  },

  handleKJModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const modelNumberInput = document.querySelector('#model-number-field')
    const sizeOfGrillField = document.querySelector('#size-of-grill-field')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
      sizeOfGrillField.setAttribute('value', values[1])
    })
    modelNumberInput.addEventListener('blur', function () {
      modelNumberSubmit.value = 'Other: ' + this.value
    })
  },

  handleMBProductTypeDropdown () {
    const models =
    {
      3: [
        ['20091013', 'Chicken stand'],
        ['20100115', 'Chrome wire skimmer with long handle'],
        ['20100315', '2-ounce injector'],
        ['20100316', 'Cold smoker accessory kit'],
        ['20100715', 'Grill pan and pizza stone'],
        ['20100814', 'Universal side shelf'],
        ['20100914', 'Smoker accessory kit'],
        ['20101014', 'Smoker leg kit with wheels'],
        ['20101015', 'Smoker leg kit'],
        ['20101115', '12-inch thermometer'],
        ['20101613', 'Smoker side shelf'],
        ['20102013', 'Smoker rack kit, with supports'],
        ['20102113', 'Smoker rack kit, 30-inch'],
        ['23101009', '2-ounce injector'],
        ['23101909', '6-inch thermometer'],
        ['MB20080110', 'Cover, 30-inch electric smoker'],
        ['MB20080118', 'Cover, XL propane/pellet smoker'],
        ['MB20080119', 'Cover, 30-inch electric smoker'],
        ['MB20080210', 'Cover, 40-inch electric smoker'],
        ['MB20080218', 'Cover, XL propane smoker'],
        ['MB20080220', 'Cover, Gravity Series 560'],
        ['MB20080221', 'Cover, Gravity Series 800'],
        ['MB20080318', 'Cover, ThermoTemp XL and Pellet Smoker'],
        ['MB20080319', 'Cover, 30-inch electric smoker'],
        ['MB20080321', 'Cover, Digital Charcoal Smoker'],
        ['MB20080418', 'Cover, propane/pellet smoker'],
        ['MB20080419', 'Cover, 41-inch Propane/Pellet Smoker'],
        ['MB20080522', 'Cover, Portable Charcoal Grill'],
        ['MB20080924', 'Cover, 30-inch Small Smoker'],
        ['MB20081220', 'Cover, Gravity Series 1050'],
        ['MB20090113', 'Sausage hanger'],
        ['MB20090115', '40-inch smoker mat'],
        ['MB20090211', 'Wire rib rack'],
        ['MB20090215', '30-inch smoker mat'],
        ['MB20090719', 'Rotisserie kit'],
        ['MB20090819', '30-inch broiler kit'],
        ['MB20090919', '40-inch broiler kit'],
        ['MB20091219', '30-inch broiler pan'],
        ['MB20091220', 'Gravity Series rotisserie'],
        ['MB20091319', '40-inch broiler pan'],
        ['MB20091419', '30-inch v-notch rack'],
        ['MB20091420', 'Gravity Series 560 warming racks'],
        ['MB20091519', '40-inch v-notch rack'],
        ['MB20091719', '40-inch rack mesh, chrome'],
        ['MB20092918', '40-inch smoker rack accessory kit'],
        ['MB20093118', 'Smoker meat probe, 52-inch cord'],
        ['MB20100112', 'Slow smoker'],
        ['MB20100116', 'Carving gloves, gray'],
        ['MB20100613', '40-inch smoker insulation blanket'],
        ['MB20100818', 'Portable smoker bag'],
        ['MB20100922', 'QuickCollapse cart'],
        ['MB20101114', 'Smoker leg extension kit'],
        ['MB20101719', 'Leg kit with side braces'],
        ['MB20101819', 'Smoker side shelf'],
        ['MB20181522', 'Gravity Series 560 front shelf'],
        ['MB20181622', 'Gravity Series 1050 griddle'],
        ['MB20181722', 'Pizza oven'],
        ['MB20183725', 'Flat-top Griddle Insert'],
        ['Other', '']
      ],
      5: [
        ['20010610', 'Electric Fish Fryer'],
        ['20100809', 'Oil Free'],
        ['23010115', '8-Liter, Analog'],
        ['23010911', 'Electric fryer'],
        ['23011014', 'Stainless Steel, Analog'],
        ['23011114', 'XL, Stainless Steel, Timer, Analog'],
        ['23011514', 'No Timer'],
        ['23013314', 'XL'],
        ['23013414', 'XL'],
        ['23013515', '10-Liter, Digital'],
        ['23014314', 'XXL, Stainless Steel Lid, Digital'],
        ['23014414', 'XXL, Stainless Steel, Digital'],
        ['23014614', 'XXL, Black, Digital'],
        ['MB20010118', '8-Liter Fryer/Boiler/Steamer, Analog, US'],
        ['MB20012420', 'XL Fryer/Boiler/Steamer'],
        ['MB20013020', '20-Quart Outdoor Air Fryer, US'],
        ['MB23010118', '8-Liter, Stainless Steel, Analog'],
        ['MB23010618', '10-Liter, Stainless Steel, Timer, Analog'],
        ['MB23010718', 'Oil Free, Analog'],
        ['MB23010809', 'Oil Free, Analog'],
        ['MB23010818', '10-Liter, Blue, Stainless Steel Lid, Analog'],
        ['MB23011018', '10-Liter, Onyx, Stainless Steel Lid, Analog'],
        ['MB23011418', '10-Liter, Stainless Steel, Digital'],
        ['MB23011518', '10-Liter, Platinum, Digital'],
        ['MB23011618', '10-Liter, Blue, Digital'],
        ['MB23011718', '10-Liter, Red, Digital'],
        ['MB23011818', '10-Liter, Onyx, Digital'],
        ['MB23011918', '10-Liter, Digital'],
        ['MB23012418', '10-Liter, Stainless Steel Film, Analog'],
        ['MB23012618', '10-Liter, Onyx Film, Analog'],
        ['MB23012718', '10-Liter, Red Film, Analog'],
        ['MB23015018', '5-Liter, Stainless Steel, Analog'],
        ['MB23015118', '5-Liter, Stainless Steel, Thermometer, Gloves, Analog']
      ],
      6: [
        ['20020107', '30-Quart Propane'],
        ['MB20020107', '30-Quart Propane'],
        ['MB20020120', 'ThermoTemp Propane Fryer']
      ],
      25: [
        ['MB20040122', 'Gravity Series 800, No Griddle'],
        ['MB20040220', 'Gravity Series 560, N. America'],
        ['MB20040221', 'Gravity Series 800, With Griddle, N. America'],
        ['MB20041023', 'Gravity Series 600, N. America'],
        ['MB20041223', 'Gravity Series XT, N. America'],
        ['MB20042221', 'Gravity Series 800, With Griddle, EU/UK/AUS/NZ'],
        ['MB20041020', 'Gravity Series 560, EU/UK/AUS/NZ'],
        ['MB20041823', 'Gravity Series 900, N. America'],
        ['MB20041220', 'Gravity Series 1050, N. America'],
        ['MB20041320', 'Gravity Series 1050, EU/UK/AUS/NZ'],
        ['MB20041525', 'Gravity Series 1150, N. America'],
        ['MB20041625', 'Gravity Series 1150, EU/UK/AUS/NZ'],
        ['MB20041423', 'Gravity Series 600, EU/UK/AUS/NZ'],
        ['MB20043024', 'Gravity Series XT, EU/UK/AUS/NZ'],
        ['Other', '']
      ],
      16: [
        ['20060516', '30-inch, Black, 2 Doors'],
        ['MB20060321', '40-inch Digital Charcoal Smoker, N. America'],
        ['MB20061321', '40-inch Digital Charcoal Smoker, EU/UK/AUS/NZ'],
        ['MB25060616', 'Bullet Smoker, Black, N. America']
      ],
      17: [
        ['20050412', 'With Wheels and Handle'],
        ['MB20051520', 'Dual Fuel Smoker, Germany'],
        ['MB20051620', 'No Regulator, EU/UK/NZ'],
        ['MB20054819', '2 Doors, Wheels, EU'],
        ['MB26050412', 'Pro Series, Black, 2 Doors, N. America']
      ],
      18: [
        ['20070111', '30-inch, Black, Analog'],
        ['20070115', '40-inch, Stainless Steel Door, Window, Digital'],
        ['20070210', '30-inch, Black, Analog'],
        ['20070213', '30-inch, Black, Digital'],
        ['20070215', '40-inch, Stainless Steel Door, Window, Legs, Digital'],
        ['20070311', '40-inch, Stainless Steel, Window, Digital'],
        ['20070315', '40-inch, Stainless Steel Door, Window, Digital'],
        ['20070411', '30-inch, Stainless Steel Door, Window, Digital'],
        ['20070615', '40-inch, Stainless Steel Door, Window, Legs, Digital'],
        ['20070814', '30-inch, Black, Digital, with Cover'],
        ['20070910', '30-inch, Black, Digital'],
        ['20071012', '30-inch, Black, Analog'],
        ['20071014', '30-inch, Black, Digital'],
        ['20071115', '40-inch, Black, Digital'],
        ['20071117', '30-inch, Black, Digital'],
        ['20071217', '30-inch, Black, Digital'],
        ['20071218', '30-inch, Black, Digital'],
        ['20071317', '30-inch, Black, Digital'],
        ['20071417', '30-inch, Black, Digital'],
        ['20071517', '30-inch, Black, Digital'],
        ['20071612', '30-inch, Black, Digital'],
        ['20071814', '30-inch, Black, with Meat Probes, Digital'],
        ['20071910', '30-inch, Black, Window, Digital'],
        ['20072115', '30-inch, Stainless Steel Door, Window, Digital'],
        ['20072215', '30-inch, Stainless Steel Door, Window, Digital'],
        ['20072315', '30-inch, Stainless Steel Door, Window, Digital'],
        ['20072415', '30-inch, Stainless Steel Door, Window, Legs, Digital'],
        ['20072715', '30-inch, Stainless Steel Door, Window, Legs, Digital'],
        ['20072817', 'Portable, Black, Analog'],
        ['20072916', '40-inch, Stainless Steel, Window, Wheels, Digital'],
        ['20073012', '40-inch, Stainless Steel Door, Window, Digital'],
        ['20073115', '30-inch, Black, Digital'],
        ['20073315', '30-inch, Black, Digital'],
        ['20074516', '30-inch, Red Door, Analog'],
        ['20074517', '30-inch, Pewter Door, Analog'],
        ['20075315', '40-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20075415', '40-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20075515', '40-inch, UBody, Stainless Steel Door, Window, Digital, with Cover'],
        ['20075516', '30-inch, Black, Window, Digital, with Cover'],
        ['20075517', '30-inch, Black, Analog'],
        ['20075615', '40-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20076716', '30-inch, Red Door, Window, Digital'],
        ['20076816', '30-inch, Blue Door, Window, Digital'],
        ['20076916', '30-inch, Black Door, Window, Digital'],
        ['20077016', '30-inch, Stainless Steel Door, Window, Digital'],
        ['20077116', '30-inch, Green Door, Window, Digital'],
        ['20077515', '30-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20077615', '30-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20077815', '30-inch, UBody, Stainless Steel Door, Window, Digital'],
        ['20078015', '30-inch, UBody, Stainless Steel Door, Window, Digital, with Cover'],
        ['20078715', '30-inch, UBody, Black, Digital'],
        ['20078815', '30-inch, UBody, Black, Digital'],
        ['20079015', '30-inch, UBody, Black, Digital'],
        ['MB20070115', '40-inch, Stainless Steel Door, Window, Digital'],
        ['MB20070122', '40-inch, Legs, Digital'],
        ['MB20070210', '30-inch, Black, 3 Racks, Analog'],
        ['MB20070421', '30-inch, Black, Window, Legs, Digital, N. America'],
        ['MB20070619', '30-inch, Black, Window, Wheels, Digital'],
        ['MB20070719', '30-inch, Black, Window, Digital'],
        ['MB20070924', '710 Digital Electric WiFi Smoker, N. America'],
        ['MB20071117', '30-inch, Black, Digital, N. America'],
        ['MB20071322', '30-inch, Black, Window, Digital, US'],
        ['MB20071418', '30-inch, Black, Digital'],
        ['MB20071518', '30-inch, Stainless Steel Door, Legs, Digital'],
        ['MB20071619', '40-inch, Black, Window, Wheels, Digital, N. America'],
        ['MB20071819', '40-inch, Stainless Steel Door, Window, Legs, Wheels, Digital, US'],
        ['MB20072024', '710 Digital Electric WiFi Smoker, EU'],
        ['MB20072124', '710 Digital Electric WiFi Smoker, UK'],
        ['MB20072115', '30-inch, Stainless Steel Door, Window, Digital'],
        ['MB20072218', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20072318', '30-inch, Black, Window, Digital'],
        ['MB20072518', '30-inch, Black, Window, Digital, with Cover'],
        ['MB20072618', '40-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20072718', '40-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20072918', '40-inch, Black, Wheels, Digital, N. America'],
        ['MB20073018', '40-inch, Black, 2 Wheels, Legs, Digital'],
        ['MB20073119', 'MES 130G, 30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20073220', 'MES 430G, 30-inch, Digital'],
        ['MB20073320', 'MES 430G, 30-inch, Digital'],
        ['MB20073420', 'MES 130P, 30-inch, Digital, UK'],
        ['MB20073519', 'MES 130P, 30-inch, Digital'],
        ['MB20073919', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20074218', '30-inch, Black, Analog'],
        ['MB20074719', '40-inch, Stainless Steel Door, Window, Wheels, Digital, N. America'],
        ['MB20075118', '40-inch, Stainless Steel Door, Window, Wheels, Legs, Digital'],
        ['MB20075519', '40-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20075617', 'MES 130B, 30-inch, Black, Digital, EU'],
        ['MB20075917', '40-inch, Black, Wheels, Digital, EU'],
        ['MB20076219', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20076419', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20076718', '40-inch, Stainless Steel Door, Window, Digital'],
        ['MB20077018', '30-inch, Black, Digital, UK'],
        ['MB20077118', '40-inch, Black, Wheels, Digital, UK'],
        ['MB20077119', '40-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20077419', 'MES 440S, 40-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB20077618', '30-inch, 2 Racks, Legs, Analog'],
        ['MB20078319', '40-inch, Stainless Steel Door, Window, Wheels, Legs, Digital'],
        ['MB20078918', '30-inch, Black, Digital, AUS'],
        ['MB20079218', '40-inch, Black, Wheels, Digital, AUS'],
        ['MB20079819', 'MES 130P, Black, Window, Wheels'],
        ['MB21071012', '30-inch, Black, Analog'],
        ['MB21071218', '30-inch, Black, Digital'],
        ['MB21072119', '30-inch, Black, Heels, Digital'],
        ['MB21072218', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB21072319', '30-inch, Adventure Series, Window, 6 Racks, Digital'],
        ['MB21072618', '30-inch, Adventure Series, Window, 6 Racks, Digital, N. America'],
        ['MB21072719', '40-inch, Adventure Series, Window, 6 Racks, Digital, N. America'],
        ['MB21072918', '40-inch, Black, Wheels, Digital'],
        ['MB21076819', '30-inch, Black, Window, Legs, 2 Wheels, Digital'],
        ['MB21077819', '40-inch, Black, Window, Legs, 2 wheels, 2 Casters, Digital'],
        ['MB25071217', '30-inch, JMSS, Black, Digital, US'],
        ['MB25072215', '30-inch, Stainless Steel Door, Window, Digital'],
        ['MB25073519', '30-inch, Stainless Steel Door, Window, Wheels, Digital'],
        ['MB25075517', '30-inch, Black, Legs, Analog, US'],
        ['MB26071317', '30-inch, Black, Digital'],
        ['MB26072415', '30-inch, Stainless Steel Door, Window, Wheels, Legs, Digital'],
        ['MB26073519', '30-inch, Black, Window, Wheels, Legs, Digital, US'],
        ['MB28071517', '30-inch, Black, Digital'],
        ['Other', '']
      ],
      19: [
        ['20050211', '40-inch, Black'],
        ['20051314', '44-inch, Black, 2-doors, window'],
        ['20051316', '40-inch, Black, 2-doors, window'],
        ['20051416', '40-inch, Black, 2-doors, window'],
        ['20051713', '30-inch, 2 racks'],
        ['MB20050118', '30-inch, Black, 2-doors, window'],
        ['MB20050211', '40-inch, Black'],
        ['MB20050418', '40-inch, Black, 2-doors, window'],
        ['MB20050511', '30-inch, 2 racks'],
        ['MB20050614', '44-inch, Black, 2-doors, window'],
        ['MB20050716', '30-inch, Black, 2-doors, window'],
        ['MB20051311', '30-inch, Black, 2-doors'],
        ['MB20051316', '40-inch, Black, 2-doors, window'],
        ['MB20052318', '30-inch, Black, 2-doors'],
        ['MB20054619', 'ThermoTemp, 30-inch'],
        ['MB21050813', '30-inch, Black, 2-doors'],
        ['MB21050814', '40-inch, Black, 2-doors, 6 racks'],
        ['MB21050916', '30-inch, Black, 2-doors, window'],
        ['MB21051213', '40-inch, Black'],
        ['MB21051313', '40-inch, Black'],
        ['MB21051314', '44-inch, Black, 2-doors, window'],
        ['MB21051416', '40-inch, Black, 2-doors, window'],
        ['MB25050217', '30-inch, Black, 2-doors'],
        ['MB25050816', '30-inch, Black, 2-doors, window']
      ],
      28: [
        ['MB20041124', 'AutoIgnite Series 545, N. America'],
        ['MB20040522', 'Portable Charcoal Grill, N. America'],
        ['MB20040622', 'Portable Charcoal Grill, International'],
        ['MB20040722', 'Portable Charcoal Grill, with cart, N. America'],
        ['MB20040819', 'Charcoal Wagon, 30-inch (76 cm)'],
        ['MB20040822', 'Portable Charcoal Grill, with cart, International'],
        ['MB20040919', 'Charcoal Wagon, 36-inch (91 cm)'],
        ['MB20041819', 'Kamado Grill'],
        ['MB20042724', 'AutoIgnite Series 545, International'],
        ['SH19041319', 'Smoke Hollow Charcoal Wagon, 30-inch (76 cm)'],
        ['SH19041519', 'Smoke Hollow Charcoal Wagon,  36-inch (91 cm)'],
        ['Other', '']
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    const modelText = document.querySelector('#model-number-text')
    const modelLabel = document.querySelector('#model-number-label')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    // const modelLabel2 = document.querySelector('#model-number-label2')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar
    // leave star on both - doesn't matter because hidden when not required
    modelLabel.innerHTML = withStar
    // modelLabel2.innerHTML = withStar

    productTypeField.addEventListener('change', function () {
      modelSelect.length = 1
      if (models[this.value]) {
        models[this.value].forEach((element) => {
          if (element[1]) {
            modelSelect.append(new Option(element[0] + ', ' + element[1], element[0]))
          } else {
            modelSelect.append(new Option(element[0], element[0]))
          }
        })
        /* make it required */
        modelSelect.setAttribute('required', true)
        modelSelect.removeAttribute('disabled')
        modelSelect.closest('.a-input-select').classList.remove('hidden')
        modelText.removeAttribute('required')
        modelText.setAttribute('disabled', true)
        modelText.closest('.a-input-text').classList.add('hidden')
      } else if (this.value === '37') {
        /* gift card, no model number required */
        modelSelect.removeAttribute('required')
        modelSelect.setAttribute('disabled', true)
        modelSelect.closest('.a-input-select').classList.add('hidden')
        modelText.removeAttribute('required')
        modelText.setAttribute('disabled', true)
        modelText.closest('.a-input-text').classList.add('hidden')
        modelNumberSubmit.value = 'Gift Card'
      } else {
        /* nothing to select, not required */
        modelSelect.removeAttribute('required')
        modelSelect.setAttribute('disabled', true)
        modelSelect.closest('.a-input-select').classList.add('hidden')
        modelText.setAttribute('required', true)
        modelText.removeAttribute('disabled')
        modelText.closest('.a-input-text').classList.remove('hidden')
      }
    })
  },

  handleMBModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    const modelText = document.querySelector('#model-number-text')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
    })
    modelText.addEventListener('blur', function () {
      modelNumberSubmit.value = 'Other: ' + this.value
    })
  },
  handleCGProductTypeDropdown () {
    const models =
    {
      29: [
        ['1055', 'Cover, Gambler and Maverick'],
        ['13737', 'Cover, Outlaw / Smokin\' Outlaw'],
        ['15555', 'Cover, Super Pro / Pro Deluxe / Deluxe Griller'],
        ['1655', 'Cover, Smokin\' Champ'],
        ['16755', 'Cover, AKORN'],
        ['18080', 'Cover, Double Play DFGC Grill (Home Depot)'],
        ['2187', 'Cover, Traditional'],
        ['2323', 'Cover, Wrangler'],
        ['2455', 'Cover, Table Top'],
        ['2955', 'Cover, Legacy Grill Cover'],
        ['2993', 'Cover, Stealth 3 Burner Gas Grill Cover'],
        ['3055', 'Cover, Grillin Pro3'],
        ['3087', 'Cover, 3 Burner Gas Grill'],
        ['3375', 'Camp Stove Grill Cover'],
        ['3737', 'Cover, Outlaw'],
        ['5055', 'Cover, Dual Function 2 Burner Grill Cover'],
        ['5533', 'Cover, Universal'],
        ['5555', 'Cover, Super Pro / Pro Deluxe / Deluxe Griller'],
        ['6060', 'Cover, Patio Pro'],
        ['6455', 'E6480 Grill Cover'],
        ['6555', 'Cover, AKORN w/ Cart'],
        ['6659', 'Cover, AKORN Jr.'],
        ['6755', 'Cover, AKORN'],
        ['8055', 'Cover, Texas Trio, Carton (HD)'],
        ['8075', 'Cover, Griddle, 4 Burner'],
        ['8080', 'Cover, Duo'],
        ['8087', 'Cover, Dual Function G&C Grill'],
        ['8175', '2B Griddle Cover'],
        ['8195', 'Cover, Grand Champ, 8100'],
        ['8265', '8250 Grill Cover'],
        ['8275', 'Cover, Griddle, Portable'],
        ['8295', 'Dakota 8235 Grill Cover'],
        ['8355', '8328 / 8428 Griddle Cover'],
        ['8575', 'Cover, Premium Griddle'],
        ['8787', 'Cover, Hybrid Gas&Charcoal'],
        ['8955', 'Cover, Competition Pro'],
        ['9155', 'Cover, Pellet Grill'],
        ['9955', 'Tank Cover']
      ],
      30: [
        ['102535', 'Grate Lifter'],
        ['1135', 'Grate Hook'],
        ['16620', 'AKORN  (Graphite)  Metal Side Shelves'],
        ['19586', 'Charcoal Chimney'],
        ['4040', 'Charcoal Basket'],
        ['5022', 'Rotisserie Kit'],
        ['6204', 'U-RACK RIB RACK'],
        ['6205', 'Drip Pan'],
        ['6206', 'Wireless Remote Thermometer'],
        ['6208A', 'Beer Can Chicken Rack'],
        ['6214', 'AKORN Adjustable Fire Grate'],
        ['6304', 'Pocket (Folding Probe) Thermometer'],
        ['6315', 'Remote Thermometer'],
        ['8603', '3n1 Brush (scour pad + nylon bristles (no PDQ)'],
        ['8605', 'Basting Brush'],
        ['8607', 'Tongs'],
        ['8609', 'Spray Bottle'],
        ['8610', 'Skewers 4 Pack SS'],
        ['8611', 'Scrub Brush'],
        ['8619', '3-in-1 Safe Brush'],
        ['8621', 'Bristle Free Brush - 3 Head (no PDQ)'],
        ['8651', 'Tool Kit (Spat/Tong/Fork) (no PDQ)'],
        ['8655', '4-Piece Premium Tool Kit - Card Wrap * (discontinued)'],
        ['8672', 'Large Cut BBQ Spatula'],
        ['8805', 'Apron'],
        ['8813', 'Burger Press'],
        ['8814', 'Bacon Press'],
        ['8824', 'Spice Dredge 2pk'],
        ['8831', 'Universal Spatula x2'],
        ['8842', 'Magnetic Tool Hooks  3pk'],
        ['8852', '18oz Squirt Bottles 2pk'],
        ['8860', 'Grill Glove'],
        ['9305', 'Grate Scraper'],
        ['9315', 'Meat Claw'],
        ['9504', '4 Pc. BBQ Tool Set (discontinued)'],
        ['9520', 'Smoker Box (discontinued)'],
        ['9580', 'Charcoal Chimney'],
        ['9586', 'Charcoal Chimney'],
        ['9875', 'Gravity Fed Cover']

      ],
      31: [
        ['8760', 'Universal Griddle Stand'],
        ['8865', 'Griddle Scouring Pads (5 Pack)'],
        ['8879', 'Heavy Duty Griddle Spatula'],
        ['8892', 'Griddle Spatula Mat'],
        ['8903', 'Grease Cup Liners 10pk'],
        ['8905', 'Griddle Starter Kit (2 Spatulas + 2 Liquid Dispensers + Chopper)'],
        ['8922', 'Griddle Cleaning Kit (Brush + Scour pads'],
        ['8933', 'Breakfast Kit --- includes bacon press'],
        ['8953', 'Egg Ring Set CG Red (silicone) 4pk'],
        ['8966', 'Flat Iron 12" Melting Dome'],
        ['8977', 'Griddle Scraper'],
        ['8999', 'Griddle Conditioner'],
        ['E8940', 'Flat Iron Portable LP Tank Adapter Kit']
      ],
      32: [
        ['6203', 'Wok'],
        ['6207', 'Turkey Roaster']

      ],
      33: [
        ['9800', 'Gravity Fed Charcoal - Blue'],
        ['9804', 'Gravity Fed Charcoal']
      ],
      7: [
        ['1016', 'Maverick'],
        ['1224', 'Smokin\' Pro'],
        ['1329', 'Smokin\' Pro'],
        ['1416', 'Gambler'],
        ['1515', 'Patio Pro'],
        ['1616', 'Patio Pro(steel shelf)'],
        ['1624', 'Smokin\' Champ'],
        ['1733', 'Smokin\' Champ'],
        ['1816', 'Portable Gambler'],
        ['2121', 'Super Pro'],
        ['2123', 'Wrangler'],
        ['2130', 'Blazer'],
        ['2137', 'Outlaw'],
        ['2175', 'Classic'],
        ['2197', '30" Traditional Charcoal Grill'],
        ['2223', 'Wrangler (steel shelf)'],
        ['2525', 'Super Pro 2.0'],
        ['2623', 'Wrangler'],
        ['2727', 'Deluxe Barrel Charcoal Grill'],
        ['2735', 'Pro Deluxe XL'],
        ['2799', 'Raider'],
        ['2823', 'Wrangler (Metal Side & Front Shelf)'],
        ['2828', 'Pro Deluxe'],
        ['2929', 'Pro Deluxe (steel shelf)'],
        ['3018', 'Smokin\' Ace'],
        ['3724', 'Smokin\' Outlaw'],
        ['8100', 'Grand Champ HD Barrel'],
        ['8125', 'Competition Pro'],
        ['8235', 'Dakota Offset Smoker'],
        ['8250', 'Grand Champ 2021'],
        ['CG30040825', 'Barrel Pro'],
        ['CG30044223', 'Smokin\' Pro'],
        ['E1016', 'Maverick'],
        ['E1224', 'Smokin\' Pro'],
        ['E1416', 'Gambler'],
        ['E1515', 'Patio Pro'],
        ['E1733', 'Smokin\' Champ 2.0'],
        ['E1816', 'Portable Gambler'],
        ['E2123', 'Wrangler'],
        ['E2130', 'Blazer'],
        ['E2175', 'Classic'],
        ['E2197', '30" Traditional Charcoal Grill'],
        ['E2727', 'Pro Deluxe'],
        ['E2735', 'Pro Deluxe XL'],
        ['E2827', 'Pro Deluxe'],
        ['E2828', 'Deluxe Griller'],
        ['E3018', 'Smokin\' Ace'],
        ['E3724', 'Smokin\' Outlaw3A)']
      ],
      21: [
        ['9020', 'Pellet Grill Char-Griller'],
        ['9040', 'Pellet Grill Char-Griller']
      ],
      34: [
        ['2903', 'Stealth 3 Burner Gas Grill with Side Burner'],
        ['3001', 'Grillin\' Pro (gas)'],
        ['3072', '3 Burner Gas Grill'],
        ['3138', '3 Burner Camp Stove'],
        ['3338', '3 Burner Camp Stove'],
        ['E3001', 'Grillin\' Pro (gas)'],
        ['E3072', '3 Burner Gas Grill'],
        ['E5072', 'Dual 3 Burner Gas & Charcoal Grill']
      ],
      35: [
        ['3070', 'Trio (gas/Char/SFB)'],
        ['5030', 'Dual 2 Burner Gas & Charcoal Grill'],
        ['5037', 'Dual Threat'],
        ['5050', 'Duo (gas&charcoal)'],
        ['5072', 'Dual 3 Burner Gas & Charcoal Grill'],
        ['5650', 'Double Play - Dual Function Gas & Charcoal Grill'],
        ['5750', 'Hybrid Gas & Charcoal Grill'],
        ['CG30282925', 'FlexFuel (N. America)'],
        ['CG30281224', 'FlexFuel Plus (N. America)'],
        ['E5030', 'Dual 2 Burner Gas & Charcoal Grill'],
        ['E5037', 'Dual Threat'],
        ['E5750', 'Hybrid Gas & Charcoal Grill']
      ],
      36: [
        ['8036', 'Flat Iron Gas Griddle'],
        ['8128', 'Flat Iron 2 Burner Griddle'],
        ['8136', 'Flat Iron Gas Griddle with Hinged Lid 36"'],
        ['8217', 'Flat Iron Portable Griddle'],
        ['8328', 'Flat Iron 3 Burner Griddle, Gray Lid and Control'],
        ['8428', 'Flat Iron 3 Burner Griddle, Black'],
        ['8536', 'Flat Iron Premium Griddle'],
        ['8728', '28" 2B FLAT IRON GRIDDLE W LID'],
        ['8730', '30" 3B FLAT IRON GRIDDLE W LID'],
        ['8736', '36" Flat Iron 4 Burner Griddle With Removable Lid (knockdown cart)'],
        ['8928', 'Flat Iron 2 Burner Griddle No Lid'],
        ['8936', 'Flat Iron 4-Burner Griddle'],
        ['E8428', 'Flat Iron 3 Burner Griddle, Black'],
        ['E8936', 'Flat Iron 4-Burner Gas Griddle']
      ],
      27: [
        ['6201', 'Smokin\' Stone'],
        ['6202', 'Pizza Stone 15"'],
        ['6211', 'Smokin\' Stone Jr.'],
        ['12197', 'Traditional Charcoal Grill'],
        ['16820', 'AKORN Kamado Kooker (Graphite)'],
        ['2190', 'Legacy Charcoal Grill'],
        ['22424', 'Tabletop Grill + SFB'],
        ['32424', 'Tabletop Grill + SFB - Black Wooden Handle'],
        ['52424', 'Tabletop Grill + SFB  (25mm handle)'],
        ['6520', 'AKORN Kamado with Cart (Gray)'],
        ['6614', 'AKORN Jr. Kamado'],
        ['6620', 'AKORN (RED)'],
        ['6714', 'AKORN Jr.'],
        ['6719', 'AKORN Black'],
        ['7400', 'Flavor Pro Multi-Fuel Grill'],
        ['92424', 'Tabletop Grill + SFB'],
        ['96619', 'AKORN Kamado Multi-pak (Graphite)'],
        ['96719', 'AKORN Kamado Combo Pk Black (international only)'],
        ['CG30040725', '22-inch Kettle Grill'],
        ['E06614', 'AKORN Jr. Kamado'],
        ['E06620', 'AKORN (RED)'],
        ['E16820', 'AKORN (Graphite)'],
        ['E22424', 'Side Fire Box'],
        ['E36714', 'AKORN Jr. Kamado Orange'],
        ['E4822', 'Premium Kettle Grill Black'],
        ['E56714', 'AKORN Jr. Kamado Blue'],
        ['E6480', 'AKORN Auto Kamado'],
        ['E86714', 'AKORN Jr. Kamado Gray'],
        ['E92424', 'Ttop Grill (Sheet metal legs) + SFB']
      ]
    }

    const productTypeField = document.querySelector('#product-type-field')
    const modelSelect = document.querySelector('#model-number-select')
    const modelLabel = document.querySelector('#model-number-label')
    const requiredStar = ' *'
    const noStar = modelLabel.innerHTML.replace(requiredStar, '')
    const withStar = noStar + requiredStar
    // leave star on both - doesn't matter because hidden when not required
    modelLabel.innerHTML = withStar

    productTypeField.addEventListener('change', function () {
      modelSelect.length = 1
      if (models[this.value]) {
        models[this.value].forEach((element) => {
          modelSelect.append(new Option(element[0] + ', ' + element[1], element[0]))
        })
        /* make it required */
        modelSelect.setAttribute('required', true)
        modelSelect.removeAttribute('disabled')
        modelSelect.closest('.a-input-select').classList.remove('hidden')
      } else {
        /* nothing to select, not required */
        modelSelect.removeAttribute('required')
        modelSelect.setAttribute('disabled', true)
        modelSelect.closest('.a-input-select').classList.add('hidden')
      }
    })
  },

  handleCGModelNumber () {
    const modelSelect = document.querySelector('#model-number-select')
    const modelNumberSubmit = document.querySelector('#mb-model-number-field')
    modelSelect.addEventListener('change', function () {
      const values = this.value.split(',')
      modelNumberSubmit.setAttribute('value', values[0])
    })
  },

  handleNewsletterOptIn (optIn = document.querySelector('#opt-in'),
    optInValue = document.querySelector('#opt-in-value')) {
    optIn.addEventListener('click', function () {
      if (this.checked) {
        optInValue.value = 'T'
      } else {
        optInValue.value = 'F'
      }
    })
  },

  handleEmailFieldMatching (emailField = document.querySelector('#email-field'),
    confirmEmailField = document.querySelector('#confirm-email-field')) {
    // Check 2 email fields match
    confirmEmailField.addEventListener('blur', () => {
      if (emailField.value !== '' &&
        confirmEmailField.value !== '') {
        this.validateEmail(emailField, confirmEmailField)
      }
    })
    emailField.addEventListener('blur', () => {
      if ((emailField.value !== '' &&
        confirmEmailField.value !== '') &&
        confirmEmailField.value) {
        this.validateEmail(emailField, confirmEmailField)
      }
    })
  },

  // Format date input field
  formatDate (purchaseDateField = document.getElementById('purchase-date-field'),
    newDate = document.getElementById('new-date')) {
    let newFormat = ''
    let oldFormat = purchaseDateField.value
    const regEx = /^\d{4}-\d{2}-\d{2}$/

    if (!oldFormat.match(regEx)) {
      alert('Please put your date in the format of YYYY-MM-DD')
      return false
    }

    const year = oldFormat.substring(0, oldFormat.indexOf('-'))
    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1)
    let month = oldFormat.substring(0, oldFormat.indexOf('-'))

    if (month.charAt(0) === '0') {
      month = month.substring(1)
    }

    oldFormat = oldFormat.substring(oldFormat.indexOf('-') + 1)
    let day = oldFormat

    if (day.charAt(0) === '0') {
      day = day.substring(1)
    }

    newFormat = month + '/' + day + '/' + year
    newDate.value = newFormat
  },

  showError (fieldElement, message) {
    // Show error message UI
    fieldElement.classList.add('error')

    // Attept to add aria-invalid to field
    if (fieldElement.querySelector('input')) {
      fieldElement.querySelector('input').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('select')) {
      fieldElement.querySelector('select').setAttribute('aria-invalid', 'true')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'true')
    }

    // Show error message
    if (message) {
      const errorElem = fieldElement.querySelector('.error-message p')

      if (errorElem) {
        errorElem.innerHTML = message
      } else {
        console.error('Unable to show error on fieldElement:', fieldElement, 'with message:', message)
      }
    } else {
      console.error('Unable to show error on fieldElement:', fieldElement, '. Has no message:', message)
    }
  },

  hideError (fieldElement) {
    // Hide error message UI
    fieldElement.classList.remove('error')

    // Disable aria-invalid if used
    if (fieldElement.querySelector('input')) {
      fieldElement.querySelector('input').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('select')) {
      fieldElement.querySelector('select').setAttribute('aria-invalid', 'false')
    } else if (fieldElement.querySelector('textarea')) {
      fieldElement.querySelector('textarea').setAttribute('aria-invalid', 'false')
    }
  },

  hideAllErrors () {
    // text errors
    document.querySelectorAll('.a-input-text.error').forEach((field) => {
      this.hideError(field)
    })

    // select errors
    document.querySelectorAll('.a-input-select.error').forEach((field) => {
      this.hideError(field)
    })

    // date errors
    document.querySelectorAll('.a-input-date.error').forEach((field) => {
      this.hideError(field)
    })

    // file errors
    document.querySelectorAll('.a-input-file.error').forEach((field) => {
      this.hideError(field)
    })
  },

  // Focus on first error in the form
  focusFirstError (container = document.querySelector('#support-form')) {
    let firstError = container.querySelector('.a-input-text.error input, .a-input-text.error textarea, .a-input-select.error select, .a-input-date.error input, .a-input-file.error input')

    // focus on first name field if no visible errors
    if (!firstError) {
      firstError = container.querySelector('#first-name-field')
    }
    firstError.focus()
  },

  // Look for required input fields and if empty, show error message
  validateRequiredFields (container) {
    let formIsValid = true

    const requiredFields = [
      {
        container: '.a-input-text',
        input: 'input[required]'
      },
      {
        container: '.a-input-text',
        input: 'textarea[required]'
      },
      {
        container: '.a-input-select',
        input: 'select[required]'
      },
      {
        container: '.a-input-date',
        input: 'input[required]'
      },
      {
        container: '.a-input-file',
        input: 'input[required]'
      }
    ]

    for (const fieldType of requiredFields) {
      const fields = container.querySelectorAll(`${fieldType.container}:not(.hidden) ${fieldType.input}`)

      for (const field of fields) {
        if ((fieldType.container !== '.a-input-file' && field.value === '') || (fieldType.container === '.a-input-file' && field.files.length === 0)) {
          const fieldContainer = field.closest(fieldType.container)

          // Show error message
          if (fieldContainer) {
            this.showError(fieldContainer, 'This field is required.')
          } else {
            console.error('Could not find container for field: ', field)
          }

          formIsValid = false
        }
      }
    }

    return formIsValid
  },

  validateEmail (email = document.querySelector('#email-field'),
    confirmEmail = document.querySelector('#confirm-email-field')) {
    const emailValue = email.value
    const confirmEmailValue = confirmEmail.value
    const emailContainer = email.closest('.a-input-text')
    const confirmEmailContainer = confirmEmail.closest('.a-input-text')

    if (emailValue === confirmEmailValue && this.validEmail(emailValue)) {
      this.hideError(emailContainer)
      this.hideError(confirmEmailContainer)

      return true
    } else if (emailValue !== confirmEmailValue) {
      this.showError(emailContainer, 'Emails do not match')
      this.showError(confirmEmailContainer, 'Emails do not match')

      return false
    } else {
      this.showError(emailContainer, 'Not a valid email address')
      this.showError(confirmEmailContainer, 'Not a valid email address')

      return false
    }
  },

  // Handle file validation
  handleFileValidation (fileSections = ['receipt', 'model', 'additional'],
    fileSelector = 'input[type=file]',
    warningIconSelector = '.files-warning',
    progressTextSelector = '#files-progress-text',
    percentageSelector = '#percent-file-size') {
    for (const file of document.querySelectorAll(fileSelector)) {
      file.addEventListener('change', () => {
        // Run validation
        const okFileSize = this.validateFileSizes(fileSections)
        const okFileFormat = this.validateFileFormat()

        if (okFileSize && okFileFormat) {
          const warningIcons = document.querySelectorAll(warningIconSelector)
          const progressTextElement = document.querySelector(progressTextSelector)
          const percentageElement = document.querySelector(percentageSelector)

          // Remove any error messages from previous uploads
          progressTextElement.classList.remove('progressbar-error-text')
          percentageElement.classList.add('progressbar-error-text')
          warningIcons.forEach(icon => icon.classList.add('hidden'))
        }
      })
    }
  },

  // Make sure all files attached to a form are under 10MB (NetSuite limit). See contact and registration forms.
  validateFileSizes (fileSections = ['receipt', 'model', 'additional'],
    fileElements = document.querySelectorAll('input[type=file]'),
    warningIcons = document.querySelectorAll('.files-warning'),
    totalTextElement = document.querySelector('#totalFileSize'),
    progressTextElement = document.querySelector('#files-progress-text'),
    percentageElement = document.querySelector('#percent-file-size'),
    progressBarElement = document.querySelector('#files-progress-bar')) {
    // Validate total files size
    const total = this.getTotalFileSizes(fileElements)
    const ok = this.validNetSuiteUploadSize(total)

    // Update progress bar
    this.updateFilesProgressBar(total, totalTextElement, progressBarElement, percentageElement)

    // Other UI updates
    if (ok) {
      // Update file/image preview
      for (const section of fileSections) {
        this.updatePreview(section)
      }
    } else {
      alert('Files must total less than 10 MB.')

      progressTextElement.classList.add('progressbar-error-text')
      percentageElement.classList.add('progressbar-error-text')
      warningIcons.forEach(icon => icon.classList.remove('hidden'))
    }

    return ok
  },

  validateFileFormat (fileElements = document.querySelectorAll('input[type=file]'),
    warningIcons = document.querySelectorAll('.files-warning'),
    progressTextElement = document.querySelector('#files-progress-text'),
    percentageElement = document.querySelector('#percent-file-size')) {
    const ok = this.validFileFormat(['image/jpeg', 'image/png', 'image/gif', 'application/pdf'], fileElements)

    if (!ok) {
      alert('Files must be in the following formats: jpeg, png, gif, or pdf.')

      progressTextElement.classList.add('progressbar-error-text')
      percentageElement.classList.add('progressbar-error-text')
      warningIcons.forEach(icon => icon.classList.remove('hidden'))
    }

    return ok
  },

  validateBannedName (firstName, lastName) {
    const badValues = ['duesediefe', 'dymnminam', 'rorequip']
    if (badValues.includes(firstName.toLowerCase()) || badValues.includes(lastName.toLowerCase()) || firstName.toLowerCase() === lastName.toLowerCase()) {
      return false
    }
    return true
  },

  updatePreview (sectionType) {
    const previewContainer = document.querySelector(`#${sectionType}-image-preview`)
    previewContainer.classList.replace('hidden', 'flex')
    previewContainer.innerHTML = ''

    for (const file of document.querySelector(`.${sectionType}-files input[type=file]`).files) {
      if (file.type.includes('image')) {
        previewContainer.innerHTML += `
                <div class="flex flex-row gap-x-4 mb-4">
                    <div class="w-1/2">
                        <img id="${sectionType}-image-preview-image" src="${URL.createObjectURL(file)}" alt="${file.name}" width="400" height="auto">
                    </div>
                    <div class="w-1/2">
                        <div class="flex flex-col gap-y-4 justify-between p-2">
                            <p id="${sectionType}-image-preview-name" class="text-label-1 font-bold">${file.name}</p>
                            <p id="${sectionType}-image-preview-size" class="text-label-2">${this.formatFileSize(file.size)}</p>
                        </div>
                    </div>
                </div>
            `
      } else {
        previewContainer.innerHTML += `
                <div class="flex flex-col gap-y-4 mb-4">
                    <p class="text-h4"><i class="fa fa-file" area-hidden="true"></i></p>
                    <p id="${sectionType}-image-preview-name" class="text-label-1 font-bold">${file.name}</p>
                    <p id="${sectionType}-image-preview-size" class="text-label-2">${this.formatFileSize(file.size)}</p>
                </div>
            `
      }
    }
  }
}
